import { render } from "./FitReferrals.vue?vue&type=template&id=2b3226ea&scoped=true&lang=pug"
import script from "./FitReferrals.vue?vue&type=script&lang=js"
export * from "./FitReferrals.vue?vue&type=script&lang=js"

import "./FitReferrals.vue?vue&type=style&index=0&id=2b3226ea&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b3226ea"]])

export default __exports__